// Textos de Productos (guía 8.5). Finales. Prohibido acá: "más solicitado", "más
// avanzado", "detección de robos" o "hurto", "en producción", cantidad o logos de clientes.

export const productosPage = {
  selector: {
    label: "Qué enciende cada producto en el local",
    replay: "Ver de nuevo",
    layers: {
      chat: "Conversaciones",
      stock: "Stock y vencimientos",
      cam: "Cámara",
      dev: "Equipo en el local",
    },
  },
  yvyra: {
    id: "yvyra",
    body: "Yvyra contesta los mensajes de tus clientes con tu catálogo, tus precios y tu forma de hablar. Lleva el stock, avisa los vencimientos y te deja el resumen del día. Cuando no sabe algo, te lo pasa a vos.",
    does: [
      "Atiende WhatsApp con tu catálogo real.",
      "Controla el stock y avisa antes de que algo se venza.",
      "Te arma el reporte del día, sin planillas.",
      "Cuando duda, deriva a una persona.",
    ],
    data: "Lo que se puede procesar en tu negocio se procesa ahí. Cada servicio externo que usa, como WhatsApp, queda declarado por escrito antes de empezar.",
    who: "Comercios, distribuidoras y pymes que venden y atienden por WhatsApp.",
    cta: "Quiero probar Yvyra",
  },
  tajy: {
    id: "tajy",
    body: "Tajy suma visión por computadora a Yvyra. Detecta caídas, mide el aforo y encuentra faltantes y mermas, procesando el video en un equipo que vive dentro de tu local.",
    does: [
      "Detecta caídas y avisa al instante.",
      "Mide cuánta gente hay, en tiempo real.",
      "Encuentra faltantes y mermas en góndola.",
      "Ninguna alerta sobre una persona sale sin que alguien la confirme.",
    ],
    data: "El video no sale de tu local. Eso sí lo firmamos.",
    who: "Supermercados, farmacias y depósitos.",
    cta: "Avisame cuando esté",
  },
  labels: { does: "Lo que hace", data: "Tus datos", who: "Para quién" },
  roadmap: {
    title: "Hoja de ruta",
    items: [
      { name: "Ka'aguy", body: "Yvyra y Tajy para cadenas con varias sedes." },
      { name: "Modelos a medida", body: "Modelos entrenados con el vocabulario y los datos de tu organización." },
    ],
  },
  start: {
    title: "Cómo empezamos",
    steps: [
      { title: "Contanos qué te cuesta hoy.", body: "Antes de ofrecerte nada, entendemos el problema." },
      { title: "Probamos con tus datos reales.", body: "Una prueba corta, en tu operación." },
      { title: "Si funciona, lo instalamos y lo medimos con vos.", body: "" },
    ],
  },
  price: { title: "Precio", body: "Cada proyecto se cotiza aparte. Te decimos el precio antes de empezar." },
} as const;
